import { render, staticRenderFns } from "./GiftList.vue?vue&type=template&id=430cac14&scoped=true"
import script from "./GiftList.vue?vue&type=script&lang=js"
export * from "./GiftList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430cac14",
  null
  
)

export default component.exports